/**
* @usage:
*
*
*
<RadioChoice :title="radioChoice.title" :items="radioChoice.fields" v-model="{uourModel}" @change="setValue" />
* radioChoice:{
*   title:'Type:',
*   fields: [
*     {
*       name: 'push',
*        title: 'Push'
*     },
*     {
*         name: 'inPage',
*         title: 'In Page'
*      },
*      {
*         name: 'iosPush',
*         title: 'IOS Push'
*        },
*       ]
* }
* methods:{
*   setValue(e){
*     this.radioType = e
*   }
* }
*/

<script>
export default {
  name: 'RadioChoice',
  props: {
    title: {},
    items: [],
    value: {},
    group: {},
  },
  data() {
    return {
      val: null,
    };
  },
  created() {
    console.log('created', this.value);
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.val = newVal;
      },
    },
  },
  methods: {
    getName(name) {
      return `${this.group}-${name}`;
    },
  },
};
</script>

<template>
  <div class="radio-list radio-only-text">
    <div v-if="title" class="radio-list--heading">{{ title }}</div>
    <label class="radio-list--item" v-for="item in items" :key="item.name">
      <input
          class="radio-input"
          type="radio"
          v-model="val"
          :name="getName(item.name)"
          :id="group"
          :value="item.name"
          @change="(e) => $emit('change', e.target.value)">
      <div class="radio-list--visible">{{ item.title }}</div>
    </label>
  </div>
</template>
